import { observer } from "mobx-react-lite";
import { useTran } from "@/hooks";
import { SelectField } from "@/components/common";
import { INDUSTRIAL_CLASSIFICATION } from "@/lib/constants";
import { useCompanyStore } from "../hooks";

const CompanySetupStepTwo = observer(({ getFieldError, handleBlur }) => {
  const { t } = useTran();
  const { form, setField } = useCompanyStore();

  const handleIndustryChange = (event) => {
    setField("industry", event.target.value);
    handleBlur("industry")();
  };

  return (
    <div className="space-y-6">
      <SelectField
        id="industry"
        label={t("What is your industry?")}
        required
        placeholder={t("Select industry")}
        value={form.industry}
        options={INDUSTRIAL_CLASSIFICATION}
        onChange={handleIndustryChange}
        error={getFieldError("industry")}
      />
    </div>
  );
});

export default CompanySetupStepTwo;
